module.exports = __webpack_public_path__ + "img/icon_search.9773221d.svg";